// extracted by mini-css-extract-plugin
module.exports = {"not_found":"copy-succession-planning_not_found__klnUe"};